import { useState, useEffect } from 'react';
import { breakpoints } from 'utility/mediaQueries';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoints.md);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoints.md);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
